var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSelectArrow = function SvgIcSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.469 11.38a.7.7 0 0 0 1.062 0l4.478-5.224A.7.7 0 0 0 12.478 5H3.522a.7.7 0 0 0-.532 1.156L7.47 11.38Z"
  })));
};
export default SvgIcSelectArrow;